import { Users, Building2, Cpu, UsersRound, Utensils, Printer, QrCode } from 'lucide-react'
import type { LucideIcon } from 'lucide-react'
import type { AdminTab } from '../constants/adminConstants'

type TabDef = { value: AdminTab; label: string; Icon: LucideIcon }

const TEAMS_TAB: TabDef = { value: 'teams', label: 'Teams', Icon: UsersRound }
const TABLES_TAB: TabDef = { value: 'tables', label: 'Tables', Icon: Utensils }
const PRINTERS_TAB: TabDef = { value: 'printers', label: 'Printers', Icon: Printer }
const QR_TAB: TabDef = { value: 'qr', label: 'QR Codes', Icon: QrCode }

// A restaurant has tables where the other verticals have teams — same slot,
// same shape, one or the other. QR codes and printers are different: extra
// entries only a restaurant gets, sitting next to the tables they belong to —
// the codes that go on them, then the printers their tickets come out of.
function tabsFor(showTables: boolean): TabDef[] {
  return [
    { value: 'properties', label: 'Property', Icon: Building2 },
    showTables ? TABLES_TAB : TEAMS_TAB,
    ...(showTables ? [QR_TAB, PRINTERS_TAB] : []),
    { value: 'users', label: 'Users', Icon: Users },
    { value: 'devices', label: 'Devices', Icon: Cpu },
  ]
}

interface AdminTabBarProps {
  active: AdminTab
  onChange: (tab: AdminTab) => void
  showTables: boolean
}

export function AdminTabBar({ active, onChange, showTables }: AdminTabBarProps): JSX.Element {
  const tabs = tabsFor(showTables)

  return (
    <div className="flex overflow-x-auto border-b border-gray-200">
      {tabs.map(({ value, label, Icon }) => (
        <button
          key={value}
          onClick={() => onChange(value)}
          type="button"
          className={`flex shrink-0 items-center gap-2 whitespace-nowrap border-b-2 px-3 py-3 text-[14px] transition-colors sm:px-5 ${
            active === value
              ? 'border-brand-green font-semibold text-gray-900'
              : 'border-transparent text-gray-500 hover:text-gray-700'
          }`}
        >
          <Icon size={16} />
          {label}
        </button>
      ))}
    </div>
  )
}
